module.exports = __webpack_public_path__ + "img/36.d811aa13.jpeg";